import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-custom-footer',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './custom-footer.component.html',
  styleUrl: './custom-footer.component.css'
})
export class CustomFooterComponent {

}
